import { EntitySingleResponseModuleNetSuite, ItemValueBinding, ShopType, SystemCategory } from 'cs.node.utils/csapi/provisioning'
import { AttributeShopValue } from 'cs.node.utils/BindingUtils'
import { DBSchema, IDBPDatabase, openDB } from 'idb'

const DB_NAME = 'cs.appweb.3'
const DB_VERSION = 7

export interface AppwebStorage extends DBSchema {
    bindingsAttributeList: {
        key: string
        value: string[]
    },
    bindings: {
        key: [string, string], // csshopid, shopid
        value: ItemValueBinding[]
    },
    attributeShopValues: {
        key: [string, string, string, string] // attributeName, csshopid, shopid, parentBindingId
        value: AttributeShopValue[]
    },
    attributeCSValues: {
        key: string
        value: string[]
    },
    moduleNetSuite: {
        key: string,
        value: EntitySingleResponseModuleNetSuite | undefined
    },
    shopCategories: {
        key: string,
        value: SystemCategory[]
    },
    shopTypes: {
        key: string,
        value: ShopType[]
    },

    //TODO: others
}

let dbPromise: Promise<IDBPDatabase<AppwebStorage>>

export const getStorage = () => {
    if (!dbPromise) {
        dbPromise = openDB<AppwebStorage>(DB_NAME, DB_VERSION, {
            upgrade(db) {
                console.log(db.objectStoreNames)
                if (!db.objectStoreNames.contains('bindingsAttributeList')) {
                    db.createObjectStore('bindingsAttributeList')
                }
                if (!db.objectStoreNames.contains('bindings')) {
                    db.createObjectStore('bindings')
                }
                if (!db.objectStoreNames.contains('attributeShopValues')) {
                    db.createObjectStore('attributeShopValues')
                }
                if (!db.objectStoreNames.contains('attributeCSValues')) {
                    db.createObjectStore('attributeCSValues')
                }
                if (!db.objectStoreNames.contains('moduleNetSuite')) {
                    db.createObjectStore('moduleNetSuite')
                }
                if (!db.objectStoreNames.contains('shopCategories')) {
                    db.createObjectStore('shopCategories')
                }
                if (!db.objectStoreNames.contains('shopTypes')) {
                    db.createObjectStore('shopTypes')
                }

                //TODO: others
            },
        })
    }
    return dbPromise
}

export async function clearAllStores(): Promise<void> {
    const db = await getStorage()
    const tx = db.transaction(db.objectStoreNames, 'readwrite')

    const storeNames = Array.from(db.objectStoreNames)
    for (const storeName of storeNames) {
        await tx.objectStore(storeName).clear()
    }

    await tx.done
}